/**
 * type.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * /support API
 * 각종 영역에서 사용되는(주로 Footer, 혹은 분양페이지의 이벤트, 새소식) API 인터페이스
 *
 * -----------------------------------------------------------------------------------------------
 */

import APIClient from 'common-modules/general/Model/APIClientModel';
import { cdBizLnd } from 'data/configs';

import {
  RequestEventProps,
  RequestSupportFAQListAPI,
  ResponseEvent,
  ResponseEventDetail,
  ResponseNotice,
  ResponseFAQ,
  RequestFAQ,
  ResponseNoticeDetail,
  ResponseNoticeList,
  ResponseSuportMng,
  ResponseSuportMngVersion,
  ResponseSuportPsn,
  ResponseSuportPsnVersion,
  ResponseSupportFAQListAPI,
  ResponseSupportTos
} from './types';


/**
 * 약관 데이터를 가져오는 API
 * (약관 데이터는 노출 상태가 단 1개만 존재하므로 그 1개에 대한 내용만 가져옵니다)
 */
export const getTermsData = () => APIClient.support.get<ResponseSupportTos>('/tos');

export const getPrivacyPolicyData = () => APIClient.support.get<ResponseSuportPsnVersion[]>('/psn');

export const getPrivacyPolicyDataDetail = (data: string) => APIClient.support.get<ResponseSuportPsn>(`/psn/${data}`);

export const getVideoInformationProcessingData = () => APIClient.support.get<ResponseSuportMngVersion[]>('/mng');

export const getVideoInformationProcessingDataDetail = (data: string) => APIClient.support.get<ResponseSuportMng>(`/mng/${data}`);

export interface INoticeProps {
  keyword?: string;
  page?: number;
}

/**
 * 이벤트 상세 정보를 가져오는 API
 */
export const getNoticeData = ({ keyword, page }: INoticeProps) =>
  APIClient.support.get<ResponseNotice>(`notice?page=${page ? page : 1}&keyword=${encodeURIComponent(keyword || '')}`);

/**
 * 이벤트 상세 정보를 가져오는 API
 */
export const getNoticeDetailData = (data: ResponseNoticeList['noNtcPlteSral']) =>
  APIClient.support.get<ResponseNoticeDetail>(`notice/${data}`);

/**
 * 이벤트 리스트를 가져오는 API
 */
export const getEventListData = ({ cdBizLnd, clEvnt, keyword, page, state }: RequestEventProps) =>
  APIClient.support.get<ResponseEvent>(
    `/event?keyword=${keyword ? encodeURIComponent(keyword) : ''}&cdBizLnd=${cdBizLnd ? cdBizLnd : ''}&clEvnt=${
      clEvnt ? clEvnt : ''
    }&page=${page ? page : 1}&state=${state ? state : ''}`
  );
  
/**
 * 이벤트 상세 정보를 가져오는 API
 */
export const getEventDetailData = (noEventSral: string) => APIClient.support.get<ResponseEventDetail>(`event/${noEventSral}`);

/**
 * (브랜드) 자주묻는 질문 리스트를 가져오는 API
 */
 export const getSupportFAQList = (data: RequestSupportFAQListAPI) =>
  APIClient.support.get<ResponseSupportFAQListAPI>('/faq', {
    params: data
  });

/**
 * (분양) 자주 묻는 질문 정보 가져오기
 */
export const getFAQList = ({ page, faqType }: RequestFAQ) =>
APIClient.support.get<ResponseFAQ>(
  `faq?cdBizLnd=${cdBizLnd}&page=${page ? page : 1}&faqType=${faqType ? faqType : ''}&length=100`
);
